async function ClearIndustries (addressid) {

    if (
        addressid.length > 0
    ) {

            let response;

            response = await fetch ("https://api.cssi.co/query", {
                method: "POST",
                body: JSON.stringify({
                    "sp": "73", 
                    "parameters": {
                        "@AddressId": addressid,
                    },
                    "servername": "Compass-Svr3\\EXACTSQLEXPRESS", 
                    "databasename": "WebApps", 
                    "continuingfunction": null,
                    "noresults": false, 
                    "args": null
                })
            })
            .then(response => {
                return response.json();
            })
            .catch(e => {
                e.name === "AbortError" ? console.log("Fetch Aborted") : console.log(e.message);        
            })

            return Promise.resolve(response);

    }
}
 
export default ClearIndustries;